/* eslint-disable import/prefer-default-export */
export const ACTION_PLAN_STATE_SLICE_KEY = 'actionPlanState';
